import React, { useContext, useState } from 'react';
import Media from '../../components/Media/Media';
import MediaBase from '../../components/MediaBase/MediaBase';
import { ThemeValueContext } from '../../context/theme/ThemeValueContext';
import { getThemedValue } from '../../utils';
export const MediaBlock = (props) => {
    const { media } = props;
    const [play, setPlay] = useState(false);
    const { themeValue: theme } = useContext(ThemeValueContext);
    const mediaThemed = getThemedValue(media, theme);
    return (React.createElement(MediaBase, Object.assign({}, props, { onScroll: () => setPlay(true) }),
        React.createElement(MediaBase.Card, null,
            React.createElement(Media, Object.assign({}, mediaThemed, { playVideo: play })))));
};
export default MediaBlock;
